import { useState, useCallback, useMemo } from "react";
import { handleBullUpdateSocketEvent } from "../../socket/scoringSocketEvent";
import { sameUsername } from "../../helper/scoring/utils";

const useDetermineTurn = (user, opponentUser, challenger, initTurn) => {
  const [turn, setTurn] = useState(initTurn);
  const [scoreHistory, setScoreHistory] = useState([]);
  const [currentInputScore, setCurrentInputScore] = useState(null);

  const isChallenger = useMemo(
    () => sameUsername(user?.username, challenger),
    [user, challenger]
  );

  const submitScore = useCallback(
    (score) => {
      if (!turn) return;
      setScoreHistory((prev) => [...prev, score]);
      setCurrentInputScore(score);
      // Sofort abgeben — Gegner ist dran, bis Socket/Turn-Hook nachzieht
      setTurn(false);
      handleBullUpdateSocketEvent(score, user, opponentUser);
    },
    [turn, user, opponentUser]
  );

  const handleSetTurn = useCallback((value) => {
    setTurn(value);
  }, []);

  return {
    turn,
    currentInputScore,
    scoreHistory,
    submitScore,
    handleSetTurn,
    isChallenger,
  };
};

export default useDetermineTurn;
